import type { Message } from "@daangn/idl/rocketchat/api/model";
import { type NormalizedSchema, normalize } from "@data-client/normalizr";
import type { ChatMessageID, NormalizedResult } from "../types";
import type { User } from "../user/user.entity";
import { ChatMessage } from "./chatMessage.entity";

type ChatMessageNormalizerParams = {
  /**
   * NOTE: 클라이언트에서 optimistic update를 위해 임시 메시지 객체를 만들어야하는 경우가 있어, Record 타입을 허용합니다.
   */
  message: Record<string, unknown> | Message;
};
export const getNormalizedChatMessage = ({
  message,
}: ChatMessageNormalizerParams) => {
  const normalizedChatMessage = normalize<
    typeof ChatMessage,
    {
      ChatMessage: NormalizedResult<ChatMessage>;
      User: NormalizedResult<User>;
    }
  >(ChatMessage, message);

  return normalizedChatMessage;
};

type GetNormalizedChatMessageListParams = {
  messages: Message[];
};
export const getNormalizedChatMessageList = ({
  messages,
}: GetNormalizedChatMessageListParams) => {
  const normalizedChatMessageList = normalize<
    (typeof ChatMessage)[],
    {
      ChatMessage: NormalizedResult<ChatMessage>;
      User: NormalizedResult<User>;
    }
  >([ChatMessage], messages);

  return normalizedChatMessageList;
};

type GetNormalizedChatMessageByIdParams = {
  chatMessageId: ChatMessageID;
  normalizedData: NormalizedSchema<
    {
      ChatMessage: NormalizedResult<ChatMessage>;
    },
    string | undefined
  >;
};
export const getNormalizedChatMessageById = ({
  chatMessageId,
  normalizedData,
}: GetNormalizedChatMessageByIdParams): ChatMessage | undefined => {
  return normalizedData.entities.ChatMessage[chatMessageId];
};
